<template>
  <div id="attributes-dropdown">
        <div class="product-attributes-filter group">

                <div v-if="engines.length > 1" class="form-floating">
                  <select class="form-select" id="EngineSelect" aria-label="Select Engine" name="engine" v-model="engine">
                    <option :value="eng" v-for="(eng, index) in engines">{{ engineslabels[index] }}</option>
                  </select>
                  <label for="EngineSelect">Select Engine</label>
                </div>

                <br v-if="engines.length > 1">

                <div v-if="years.length > 1" class="form-floating">
                  <select class="form-select" id="YearSelect" aria-label="Select Year" name="year" v-model="year">
                    <option :value="year" v-for="year in years">{{year}}</option>
                  </select>
                  <label for="YearSelect">Select Year</label>
                </div>

                <br v-if="years.length > 1">

                <div v-if="transmissions.length > 1" class="form-floating">
                  <select class="form-select" id="TransmissionSelect" aria-label="Select Transmission" name="transmission" v-model="transmission">
                    <option :value="transmission" v-for="transmission in transmissions">{{transmission}}</option>
                  </select>
                  <label for="TransmissionSelect">Select Transmission</label>
                </div>

                <br v-if="transmissions.length > 1">

        </div>
  </div>
</template>


<script>
    import {bus} from '../../bus'
    export default {
        name: "ProductAttributesDropdowns",
        props: ["engines", "engineslabels", "years", "engine", "year", "transmissions", "transmission"],
        watch: {
            engine: function(val) {
                window.location.href = window.location.pathname + '?engine=' + val + "#prod-title";
            },
            year: function(val) {
                window.location.href = window.location.pathname + '?engine=' + this.engine + "&year=" + val + "#prod-title" ;
            },
            transmission: function(val) {
                window.location.href = window.location.pathname + '?engine=' + this.engine + "&year=" + this.year + "&transmission=" + val + "#prod-title" ;
            }
        },
        mounted() {

            //this.$root.$emit('product-attributes-engine', this.engine);

            //this.$root.$emit('product-attributes-year', this.year);

        }
    }
</script>
<style scoped>

.form-floating {
    position: relative;
}

.form-floating > .form-select {
    padding-top: 24px;
    padding-bottom: 0.625rem;
    text-transform: capitalize;
    font-size: 24px;
}
.form-floating>.form-control, .form-floating>.form-select {
    height: 64px;
    line-height: 1.25;
}

.form-floating>.form-control:focus~label, .form-floating>.form-control:not(:placeholder-shown)~label, .form-floating>.form-select~label {
    opacity: .65;
    transform: scale(.85) translateY(-0.5rem) translateX(0.15rem);
}


.form-select {
    transition: none;
}
.form-select {
    display: block;
    width: 100%;
    padding: .375rem 2.25rem .375rem .75rem;
    -moz-padding-start: calc(0.75rem - 3px);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 16px 12px;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.form-floating>label {
    transition: none;
}
.form-floating>label {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    padding: 1rem 0.75rem;
    pointer-events: none;
    border: 1px solid transparent;
    transform-origin: 0 0;
    transition: opacity .1s ease-in-out,transform .1s ease-in-out;
    font-size: 16px;
}









#attributes-dropdown {
    width: 100%;
}
#engine-label,
#year-label,
#transmission-label {
    font-size: 20px;
    line-height: 1.3;
    font-weight: 700;
}
#engine-dropdown,
#year-dropdown,
#transmission-dropdown {
    background: rgb(212,212,212);
    background: linear-gradient(0deg, rgba(212,212,212,1) 0%, rgba(252,252,252,1) 100%);
    border: 1px solid #a7a7a7;
    border-radius: 5px;
    width: 100%;
    padding: 10px;
    color: #333;
    line-height: 1.3;
    font-size: 20px;
}
</style>